import React from 'react';

import { AppContext } from '../AppContext';

const Test = () => {
	const app = React.useContext(AppContext);
	const { userdata: { isMuted, removeAds } } = app;

	const handleShowNotification = React.useCallback(() => {
		app.showNotification?.({
			title: 'Test',
			type: 'Achievement',
			image: 'https://picsum.photos/200/300',
			points: 25,
			description: 'Test description',
		});
	}, [app]);

	const handleAds = React.useCallback(() => {
		app?.setRemoveAds?.(!removeAds);
	}, [app, removeAds]);

	const handleSound = React.useCallback(() => {
		app.setIsMuted(!app.userdata.isMuted);
	}, [app]);

	return (
		<div id="Settings1" className="page1 paddingTop50">
			<div className="wrapper">
				<div className="pageTitle">
					<a className="backButton" href="#"></a>
					<h1>Test</h1>
				</div>
				<div>
					<button onClick={() => {
						app.showAd(true);
					}}>
						Show Ad
					</button>
				</div>
				<div>
					<button onClick={() => {
						app.showEnjoyGame();
					}}>
						Show Enjoy Dialog
					</button>
				</div>
				<div>
					<button onClick={() => {
						app.showShare();
					}}>
						Show Share
					</button>
				</div>
				<div>  <button onClick={() => {
					app.showNotification('Test notification');
				}}>
					showNotification
				</button>
				</div>
				<div>
					<button onClick={handleShowNotification}>
						showNotification Achievement
					</button>
				</div>
				<div>
					<button onClick={() => {
						app.navigate('Game/Test/CrazyNinja');
					}}>
						Test GameUI Mode - Test vs Crazy Ninja
					</button>
				</div>
				<div>
					<button onClick={() => {
						fetch('assets/Decks/PixaromaDeck_SpriteSheet.png').then((response) => {
							console.log(response);
						}).catch((error) => {
							console.log(error);
						});
					}}>
						fetch("assets/Decks/PixaromaDeck_SpriteSheet.png")
					</button>
				</div>
				<div>
					<button onClick={handleSound}>
						Turn sound {isMuted ? 'On' : 'Off'}
					</button>
				</div>
				<div>
					<button onClick={handleAds}>
						Ads are {removeAds ? 'Removed' : 'Enabled'}
					</button>
				</div>

			</div>
		</div>
	);
};

export default Test;
